import apiClient from "./apiClient";

const followCheckUpsApi = {
  getAll: async ({ branchId, patientId } = {}) => {
    const response = await apiClient.get("/follow-checkups", {
      params: { branchId, patientId },
    });
    return response.data;
  },
  getById: async (followCheckUpId) => {
    const response = await apiClient.get(`/follow-checkups/${followCheckUpId}`);
    return response.data;
  },
  create: async (data) => {
    const response = await apiClient.post("/follow-checkups", data);
    return response.data;
  },
  update: async (followCheckUpId, data) => {
    const response = await apiClient.patch(`/follow-checkups/${followCheckUpId}`, data);
    return response.data;
  },
  cancel: async (followCheckUpId, cancellationReason, cancelationComments) => {
    const response = await apiClient.patch(`/follow-checkups/${followCheckUpId}/cancel`, {
      cancellationReason,
      cancelationComments,
    });
    return response.data;
  },
  delete: async (followCheckUpId) => {
    const response = await apiClient.delete(`/follow-checkups/${followCheckUpId}`);
    return response.data;
  },
};

export default followCheckUpsApi;
